import { Component, OnInit, Input } from '@angular/core';
import { QueryVhweb} from 'private-angular-vhframeworks'
@Component({
  selector: 'app-banner-img',
  templateUrl: './banner-img.component.html',
  styleUrls: ['./banner-img.component.scss']
})
export class BannerImgComponent implements OnInit {
  @Input() id_parent:any;
  img:any;
  constructor(
    private queryVhweb:QueryVhweb
  ) { }

  ngOnInit(): void {
    this.queryVhweb.getComponents('banner-img',this.id_parent)
    .then(res=>{
      this.img = res.docs[0].data().img;
    })
  }

}
